import { Box, Collapse, Group, Menu, rem, UnstyledButton } from "@mantine/core";
import { IconChevronRight, IconMoneybag, IconUser } from "@tabler/icons-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./LinksGroup.module.css";

/* eslint-disable @typescript-eslint/no-explicit-any */
interface LinksGroupProps {
  icon: React.FC<any>;
  label: string;
  initiallyOpened?: boolean;
  links?: { label: string; link: string }[];
  toggleMenu: () => void;
}

export function LinksGroup({
  icon: Icon,
  label,
  initiallyOpened,
  toggleMenu
}: // links
LinksGroupProps) {
  const [opened, setOpened] = useState(initiallyOpened ?? true);
  const navigate = useNavigate();
  return (
    <>
      <UnstyledButton
        onClick={() => setOpened((o) => !o)}
        className={classes.control}
      >
        <Group justify="space-between" gap={0}>
          <Box style={{ display: "flex", alignItems: "center" }}>
            <Icon
              style={{
                width: rem(18),
                height: rem(18),
                marginInlineEnd: "var(--mantine-spacing-sm)"
              }}
            />
            <span className="link-label">{label}</span>
          </Box>
          <IconChevronRight
            className={classes.chevron}
            stroke={1.5}
            style={{
              width: rem(16),
              height: rem(16),
              transform: opened ? "rotate(-90deg)" : "none"
            }}
          />
        </Group>
      </UnstyledButton>
      <Collapse in={opened}>
        <Box className="nested-menu">
          <Menu>
            <Menu.Item
              leftSection={<IconUser size="1rem" stroke={1.5} />}
              className="menu-link"
              onClick={() => {
                toggleMenu();
                navigate("/settings/account");
              }}
              variant="filled"
            >
              Account
            </Menu.Item>
            <Menu.Item
              leftSection={<IconMoneybag size="1rem" stroke={1.5} />}
              className="menu-link"
              onClick={() => {
                toggleMenu();
                navigate("/billing");
              }}
              variant="filled"
            >
              Billing
            </Menu.Item>
          </Menu>
        </Box>
      </Collapse>
    </>
  );
}
